module.exports = __webpack_public_path__ + "static/media/facebook-20160229-130742.240154f3.jpg";